export default {"src":"/_next/static/media/Hotel.8b926654.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};